import { Types } from '@store/types';

import { checkAnyUserType, getUserPreference } from '@utils/Util';

import { setSystemUserPreferences } from '@/services/commonService';

const isAdminOrProjectDirector = () => checkAnyUserType(['ADMIN', 'PROJECT_DIRECTOR']);
const userPreference = getUserPreference();
const getColumnVisibility = (key, defaultValue) => {
	const columnSetting = userPreference?.orderDashboardColumnSetting;
	return columnSetting?.[key] !== undefined ? columnSetting[key] : defaultValue;
};

const initialState = {
	headings: [],
	isAllColumnVisible: getColumnVisibility('isAllColumnVisible', !isAdminOrProjectDirector()),
	isCriticalColumnVisible: getColumnVisibility('isCriticalColumnVisible', isAdminOrProjectDirector()),
	isProductionColumnVisible: getColumnVisibility('isProductionColumnVisible', false),
	isSampleColumnVisible: getColumnVisibility('isSampleColumnVisible', false),
	isBrandColumnVisible: getColumnVisibility('isBrandColumnVisible', true),
	isStyleColumnVisible: getColumnVisibility('isStyleColumnVisible', true),
	isFabricColumnVisible: getColumnVisibility('isFabricColumnVisible', true),
	isSweaterColumnVisible: getColumnVisibility('isSweaterColumnVisible', false),
	isPOColumnVisible: getColumnVisibility('isPOColumnVisible', true),
	isSCColumnVisible: getColumnVisibility('isSCColumnVisible', true),
	isETDColumnVisible: getColumnVisibility('isETDColumnVisible', true),
	isTnaStatusColumnVisible: getColumnVisibility('isTnaStatusColumnVisible', true),
	isExFactoryColumnVisible: getColumnVisibility('isExFactoryColumnVisible', true),
	isSPColumnVisible: getColumnVisibility('isSPColumnVisible', true),
	isDeliveryColumnVisible: getColumnVisibility('isDeliveryColumnVisible', true),
	isInspectionColumnVisible: getColumnVisibility('isInspectionColumnVisible', true)
};
const OrderDashboardReducer = (state = initialState, action) => {
	switch (action.type) {
		case Types.STORE_ORDER_DASHBOARD_TABLE_HEADINGS:
			return {
				...state,
				headings: action.payload.map((item) => ({ ...item, isColumnVisible: false }))
			};
		case Types.TOGGLE_ORDER_DASHBOARD_TABLE_COLUMN:
			return {
				...state,
				headings: state.headings.map((item) => {
					if (item.stageConstants === action.payload) {
						return { ...item, isColumnVisible: !item.isColumnVisible };
					} else {
						return item;
					}
				})
			};
		case Types.TOGGLE_ORDER_DASHBOARD_TABLE_GENERAL_COLUMN:
			const newState = { ...state, [action.payload]: !state[action.payload] };
			setSystemUserPreferences({
				...userPreference,
				orderDashboardColumnSetting: newState
			});
			return newState;
		default:
			return state;
	}
};

export default OrderDashboardReducer;
